import * as React from "react";
import { Checkbox as AntdCheckbox } from "antd";

export const Checkbox = (props: CheckboxProps) => {
  let {
    label,
    className,
    checked = false,
    disabled = false,
    handleChange
  } = props;

  return (
    <AntdCheckbox
      className={className}
      onChange={handleChange}
      checked={checked}
      {...disabled}
    >
      {label}
    </AntdCheckbox>
  );
};

interface CheckboxProps {
  name?: string;
  label?: string;
  className?: string;
  handleChange?: (e?: any) => any;
  checked?: boolean;
  disabled?: boolean;
}

export default Checkbox;



// WEBPACK FOOTER //
// ./client/modules/form/Checkbox/index.tsx